<template>
  <model-form
    ref="modelForm"
    :model="tip"
    modal-type="modal"
    read-only
  >
    <div class="row q-col-gutter-x-sm items-center">
      <router-field
        :field-value="tip.employee?.name || 'Unassigned'"
        class="col-6 sensitive-data"
        label="Employee"
        :link="{
          name: 'admin:operations-category-name-id',
          params: {
            category: 'customers',
            name: 'users',
            id: tip.employee?.id
          }
        }"
        :disable="$_.isNil(tip.employee)"
      />
      <model-form-input
        field="amount"
        class="col-6"
        label="Amount"
        :prefix="currentCircuit.localeCurrencySymbol"
        mask="#.##"
        fill-mask="0"
        readonly
      />
      <router-field
        :field-value="orderValue"
        class="col-6"
        label="Order"
        :link="{
          name: 'admin:operations-category-name-id',
          params: {
            category: 'customers',
            name: 'orders',
            id: tip.orderItem?.order?.id
          }
        }"
        :disable="$_.isNil(tip.orderItem?.order)"
      />
      <model-form-input
        field="paymentType"
        class="col-6"
        label="Payment Type"
        :decode="paymentType => $_.startCase(paymentType)"
        readonly
      />
      <formatted-date
        :value="tip.paidAt"
        class="col-6 q-mb-md"
        label="Paid At"
        component="input"
      />
      <formatted-date
        :value="tip.voidedAt"
        class="col-6 q-mb-md"
        label="Voided At"
        component="input"
      />
      <router-field
        :field-value="$_.startCase(tip.source)"
        class="col-6"
        label="Tip Pool"
        :link="{
          name: 'admin:operations-category-name-id',
          params: {
            category: 'staff',
            name: 'tip-pools',
            id: tip.tipPoolTip?.tipPool?.id
          }
        }"
        :disable="$_.isNil(tip.tipPoolTip?.tipPool)"
      />
      <router-field
        :field-value="tipShareValue"
        class="col-6"
        label="Tip Share"
        :link="{
          name: 'admin:operations-category-name-id',
          params: {
            category: 'staff',
            name: 'tip-shares',
            id: tip.tipShare?.id
          }
        }"
        :disable="$_.isNil(tip.tipShare)"
      />
    </div>
  </model-form>
</template>

<script>
import FormattedDate from 'src/modules/admin/components/FormattedDate'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import RouterField from 'src/modules/admin/components/RouterField'

export default {
  name: 'TipForm',
  components: {
    ModelForm,
    FormattedDate,
    RouterField
  },
  configuration: ['currentCircuit'],
  models: {
    tip: {
      employee: {
        fields: ['id', 'firstName', 'lastName']
      },
      orderItem: {
        fields: ['id'],
        order: {
          fields: ['id']
        }
      },
      tipShare: {
        fields: ['id'],
        tipShareRule: {
          fields: ['id', 'name']
        }
      },
      tipPoolTip: {
        fields: ['id'],
        tipPool: {
          fields: ['id']
        },
        tipPoolType: {
          fields: ['id', 'name']
        }
      }
    }
  },
  computed: {
    orderValue () {
      if (!_.isNil(this.tip.orderItem?.order)) {
        return `O${this.tip.orderItem?.order?.id}`
      } else {
        return 'No Order'
      }
    },
    tipShareValue () {
      if (!_.isNil(this.tip.tipShare?.tipShareRule)) {
        return this.tip.tipShare?.tipShareRule?.name
      } else {
        return 'Not Shared'
      }
    }
  }
}
</script>
